import React, {FC} from 'react';
import classNames from 'classnames';

import s from './baseIcon.scss';
import {SIZE_SMALL, SIZE_RESPONSIVE, SIZE_MEDIUM, SIZE_LARGE} from './constants';
export {SIZE_SMALL, SIZE_RESPONSIVE, SIZE_MEDIUM, SIZE_LARGE} from './constants';

/* Sizes actual values */
export const SIZES = {
    [SIZE_SMALL]: 16,
    [SIZE_MEDIUM]: 22,
    [SIZE_LARGE]: 34,
    [SIZE_RESPONSIVE]: '100%',
};

export type IconType = any;

export type PropsType = {
    /** Icon component */
    icon: IconType;

    /** The size of the icon. Default value is `SIZE_RESPONSIVE`. */
    size?: keyof typeof SIZES;

    /** The role of the icon. */
    role?: string;

    /** The label of the icon. */
    label?: string;

    /** The class of the icon */
    className?: string;
};

/**
 * Component for generate the icon by name from svg sprite
 * @returns {Node} React Node Instance
 */
export const Icon: FC<PropsType> = ({icon, size = SIZE_RESPONSIVE, role, label, className}) => {
    const sizeValue = SIZES[size || SIZE_RESPONSIVE];

    if (typeof icon === 'undefined') {
        // eslint-disable-next-line
        console.error('Requested icon does not exist');
        return null;
    }

    return (
        <icon.default
            width={sizeValue}
            height={sizeValue}
            className={classNames(s.container, className)}
            role={role}
            aria-label={label}
        />
    );
};

Icon.defaultProps = {
    size: SIZE_RESPONSIVE,
    role: 'presentation',
};
